import { Link } from 'react-router-dom';

/**
 * The WeClip mark, exactly as the marketing site draws it, plus the product
 * name after it.
 *
 * Nexus is not a separate brand. It is one of three things under WeClip —
 * Forge builds, Amplify grows, Nexus connects — and weclip.media already draws
 * them that way, so the header here reads `WeClip · Nexus` rather than
 * inventing a logo. The icon is the same file the site serves; the wordmark is
 * the same treatment, "We" in snow and "Clip" in the blue→violet→cyan
 * gradient.
 *
 * `alt=""` on the icon on purpose: the visible wordmark beside it already says
 * the name, and labelling the image would make a screen reader announce the
 * brand twice. The link carries the accessible name instead.
 */
export function BrandMark({ to = '/' }: { to?: string }): React.JSX.Element {
  return (
    <Link to={to} className="brandmark" aria-label="Nexus by WeClip — home">
      <img
        src="/weclip-icon.webp"
        alt=""
        width={572}
        height={481}
        decoding="async"
        draggable={false}
      />
      <span aria-hidden="true">
        We<span className="gradient-text">Clip</span>
      </span>
      <span className="product" aria-hidden="true">
        <em>Nexus</em>
      </span>
    </Link>
  );
}
